/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    CANCEL: 'Abbrechen',
    CLOSE: 'Schließen',
    CONFIRM: 'Bestätigen',
    CONFIRM_AND_NEXT: 'Bestätigen und weiter',
    CONFIRM_AND_SAVE: 'Bestätigen und speichern',
    CREATE: 'Erstellen',
    DELETE: 'Löschen',
    EDIT: 'Bearbeiten',
    NEW_POST: 'Neuer Beitrag',
    OK: 'Ok',
    REJECTED: 'Abgelehnt',
    REPLY: 'Antworten',
    SAVE: 'Speichern',
    SEND: 'Senden',
    SKIP_CROP: 'Zuschneiden überspringen',
    UPDATE: 'Aktualisieren',
    UPGRADE: 'Dem Club beitreten'
  },
  ERROR: {
    FAIL_COPYING_TO_CLIPBOARD: 'Fehler beim Kopieren in die Zwischenablage!',
    INSTAGRAM_PUBLISHING_ERROR:
      'Fehler beim Teilen des Beitrags auf Instagram.',
    INSTAGRAM_PUBLISHING_ERROR_MODAL:
      'Fehler beim Teilen des Beitrags auf Instagram. Möchten Sie trotzdem fortfahren?',
    LINK_ALREADY_EXISTS: 'Link bereits vorhanden',
    LINK_VALIDATION_FAILED: 'Link konnte nicht validiert werden',
    MANDATORY_FIELD: 'Pflichtfeld',
    MAXIMUM_CHARACTERS: 'Maximale Zeichenanzahl erreicht',
    MAXIMUM_FILE_SIZE: 'Die maximale Dateigröße beträgt 100MB!',
    MINIMUM_DIMENSIONS:
      'Die hochgeladene Datei muss die Mindestabmessungen von 480×960 haben',
    PAGE_NOT_APPROVED:
      '❌ Leider konnte deine Seite dieses Mal nicht genehmigt werden. Aber keine Sorge! ✨\n Du kannst dein Profil bearbeiten und die angegebenen Felder korrigieren, um es erneut zur Genehmigung einzureichen.',
    REACTION_LIKE:
      'Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut!',
    UNSUPPORTED_FORMAT: 'Nicht unterstütztes Format!',
    VIDEO_CROP: 'Video-Zuschnitt fehlgeschlagen!'
  },
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_AND_CONDITIONS: 'Ich akzeptiere die Geschäftsbedingungen',
    ADDITIONAL_INFORMATION: 'Weitere Informationen',
    ADDRESS: 'Adresse',
    APPROVED: 'veröffentlicht',
    ASSETS: 'Bilder oder Videos (maximale Größe 100MB)',
    ASSOCIATE_PRODUCT: 'Prozis-Produkt zuordnen',
    ASSOCIATED_PRODUCTS: 'Zugeordnete Prozis-Produkte',
    BUSINESS_PAGE: 'Business Page',
    CAPTION: 'Bildunterschrift',
    CHART_BY: 'Diagramm nach',
    COMMENTS: 'Kommentare',
    COMMISSION: 'Provision',
    COMMISSIONS: 'Provisionen',
    COMMISSIONS_LAST_30_DAYS: 'Letzte 30 Tage',
    COMPANY_NETWORK: 'Prozis',
    COMPLETED_WITHOUT_DOOR_NUMBER: 'Vollständige Adresse ohne Hausnummer',
    CONTINUE_WITH_INSTAGRAM: 'Mit Instagram fortfahren',
    COUNTRY: 'Adresse nur mit Land',
    CREATE_PROFILE: 'Profil erstellen',
    CROPPING_ASSET: '{asset} {ratio} zuschneiden',
    DELETE_POST: 'Beitrag löschen?',
    DELETE_POST_ARE_YOU_SURE:
      'Sind Sie sicher, dass Sie den Beitrag löschen möchten?',
    DESCRIPTION: 'Biografie',
    DOCUMENT: 'Document',
    DOWNLOAD: 'Herunterladen',
    DRAFT_PROFILE: 'Entwurf',
    EDIT_PROFILE: 'Seite bearbeiten',
    ENGAGEMENT: 'Interaktion',
    ERROR: 'Fehler',
    FEED: 'Feed',
    FOLLOWERS: 'Follower',
    FRIDAY: 'Friday',
    GALLERY: 'Galerie',
    HIDDEN: 'Adresse wird nicht angezeigt',
    IMAGE: 'Bild',
    INSTAGRAM: 'Instagram',
    INSTAGRAM_ACCOUNT: 'Instagram-Konto',
    LATEST_FIRST: 'Neueste zuerst',
    LEAST_PROFITABLE: 'Zuerst die weniger profitablen',
    LIKES: 'Gefällt mir',
    LIKES_DELETED: 'Gefällt mir-Angaben entfernt',
    LINK: 'Link',
    LIVE: 'Live',
    LIVES: 'Liveübertragungen',
    LOCATION_LEVEL_TYPE_CITY_COUNTRY: 'Adresse nur mit Stadt und Land',
    LOCATION_LEVEL_TYPE_COMPLETED: 'Vollständige Adresse',
    LOCATION_LEVEL_TYPE_COMPLETED_WITHOUT_DOOR_NUMBER:
      'Vollständige Adresse ohne Hausnummer',
    LOCATION_LEVEL_TYPE_COUNTRY: 'Adresse nur mit Land',
    MONDAY: 'Monday',
    MORE: '... Mehr anzeigen',
    MOST_PROFITABLE: 'Zuerst die profitableren',
    NAME: 'Name',
    NEW_FOLLOWERS: 'Neue Follower',
    NEW_POST: 'Neuer Beitrag',
    NO_PRODUCTS_FOUND: 'Keine Produkte gefunden.',
    NUMBER_OF_FILES: '{file} von {files}',
    OLDEST_FIRST: 'Älteste zuerst',
    ORIGINAL: 'Original',
    OTHER_NETWORKS: 'Instagram',
    PAGE_PHOTOS: 'Seitenfotos',
    PAST_TIME_DATE: '{value}',
    PAST_TIME_DAYS: '{value} t',
    PAST_TIME_HOURS: '{value} h',
    PAST_TIME_MINUTES: '{value} m',
    PENDING: 'ausstehend',
    POST: 'Beitrag',
    POST_COMMENTS: 'Beitragskommentare',
    POST_PRODUCTS: 'Beitragsprodukte',
    POST_VIEWS: 'Beitragsaufrufe',
    POSTING_ON_INSTAGRAM: 'Veröffentlichen auf Instagram',
    POSTS: 'Beiträge',
    PRODUCTS_HASHTAGS: 'Produkt-Hashtags',
    PRODUCTS_LINKS: 'Produktlinks',
    PROFESSIONAL_PAGE: 'Professionelle Seite',
    PROFILE: 'Profil',
    PROFILE_PHOTO: 'Profilfoto',
    PROFILE_STATUS: 'Profilstatus',
    PROFILE_VIEWS: 'Profilansichten',
    PROZIS: 'Prozis',
    PROZIS_COMMUNITY: 'Prozis-Community',
    QUESTION: 'Frage',
    QUESTION_REPLY: 'Frage beantworten',
    QUESTIONS: 'Fragen',
    REELS: 'Reels',
    REJECTED: 'nicht veröffentlicht',
    REJECTED_PROFILE: 'Abgelehnt',
    REJECTION_REASON: 'Ablehnungsgrund',
    REPLY: 'Antworten',
    REQUIRED_FIELDS: 'Pflichtfelder',
    RESET: 'Zurücksetzen',
    SATURDAY: 'Saturday',
    SEARCH: 'Suchen',
    SEARCH_AT_LEAST: 'Das Suchwort muss mindestens 3 Zeichen lang sein!',
    SEE_LESS: 'Verstecken',
    SEE_MORE: 'Mehr sehen',
    SEE_ORIGINAL: 'Original anzeigen',
    SEE_TRANSLATION: 'Übersetzung anzeigen',
    SHARE_ON_INSTAGRAM: 'Auf Instagram teilen',
    SHARE_PROFILE: 'Seite teilen',
    SOCIAL_NETWORK: 'Soziales Netzwerk',
    SOCIAL_NETWORK_COMMISSIONS: 'Provisionen des sozialen Netzwerks',
    SOCIAL_NETWORK_PAGE: 'Soziale Seite',
    SOUND: 'Ton',
    SPECIALTIES: 'Spezialitäten',
    STATISTICS_POST: 'Beitragsstatistiken',
    STATISTICS_PROFILE: 'Profilstatistiken',
    STATS_POST_TOTAL: 'Gesamte Provisionen für den Beitrag',
    STATS_POST_TOTAL_COMMENTS: 'Kommentare/Fragen zum Beitrag',
    STATS_POST_TOTAL_LIKES: 'Gefällt mir-Angaben für den Beitrag',
    STATS_POST_TOTAL_PRODUCTS: 'Mit dem Beitrag verbundene Produkte',
    STATS_POST_TOTAL_QUESTIONS: 'Beantwortete Fragen zum Beitrag',
    STATS_POST_TOTAL_VALUE: 'Wert des Beitrags',
    STATS_PROFILE_TOTAL: 'Gesamte Provisionen für Beiträge',
    STATS_PROFILE_TOTAL_COMMENTS: 'Kommentare/Fragen zu Beiträgen',
    STATS_PROFILE_TOTAL_FOLLOWERS: 'Neu gewonnene Follower',
    STATS_PROFILE_TOTAL_LIKES: 'Gefällt mir-Angaben für Beiträge',
    STATS_PROFILE_TOTAL_POSTS: 'Wert der Beiträge',
    STATS_PROFILE_TOTAL_PRODUCTS: 'Mit Beiträgen verbundene Produkte',
    STATS_PROFILE_TOTAL_QUESTIONS: 'Beantwortete Fragen zu Beiträgen',
    STORY: 'Story',
    SUCCESS: 'Erfolg',
    SUNDAY: 'Sunday',
    TERMS_AND_CONDITIONS: 'Geschäftsbedingungen',
    THURSDAY: 'Thursday',
    TITLE: 'Titel',
    TOTAL_VIEWS: 'Gesamtansichten',
    TUESDAY: 'Tuesday',
    TYPE_OF_DOCUMENT: 'Document type',
    UNFOLLOWERS: 'Entfolgte Nutzer',
    UNREAD: 'Ungelesen',
    UPDATE_POST: 'Beitrag aktualisieren',
    UPDATED: 'Aktualisiert am {date}',
    UPLOAD: 'Datei hochladen',
    UPLOADING_FILES: 'Datei(en) hochladen',
    USER_NAME: 'Benutzername',
    VIDEO: 'Video',
    VIEW_ALL_COMMENTS: 'Alle {total} Kommentare anzeigen',
    VIEW_MORE: 'Mehr anzeigen',
    VIEWS: 'Ansichten',
    VISIBILITY_LEVEL: 'Sichtbarkeitsstufe',
    WAITING_APPROVAL: 'Wartet auf Genehmigung',
    WARNING: 'Warnung',
    WEDNESDAY: 'Wednesday',
    YOUR_PROFILE: 'Dein Profil'
  },
  SENTENCE: {
    NO_QUESTIONS_YET: 'Es gibt noch keine Fragen.',
    TERMS_AND_CONDITIONS:
      'Durch die Interaktion mit dem „Sozialen Netzwerk“ von Prozis (zum Beispiel durch Kommentare und/oder das Teilen von Inhalten und Reaktionen direkt) erklärt der Benutzer, dass er die folgenden Geschäftsbedingungen (AGB) gelesen, verstanden und akzeptiert hat.\n\nProzis behält sich das Recht vor, die AGB jederzeit ohne vorherige Ankündigung zu aktualisieren. Prozis hat das Recht, alle verfügbaren rechtlichen und fairen Mittel einzusetzen.\n\nDurch den Zugriff auf das „Soziale Netzwerk“ erklärt der Benutzer, dass er mindestens 18 Jahre alt ist und übernimmt die volle Verantwortung für Beiträge, Kommentare, Bilder und Videos, die in das „Soziale Netzwerk“ hochgeladen werden („Inhalte“).\n\nDer Inhalt muss dem Benutzer gehören, der erklärt, der Autor und Inhaber aller geistigen Eigentumsrechte zu sein. Der Inhalt darf keine spezifischen Situationen, Gebäude oder Objekte darstellen, die durch Urheberrechte, Marken oder im Allgemeinen durch Marken und Logos anderer Unternehmen geschützt sind, es sei denn, der Benutzer hat die notwendige Erlaubnis zur Verwendung erhalten.\n\nDer Inhalt darf keine andere Person außer dem Benutzer enthalten, es sei denn, diese Person hat ihre schriftliche Zustimmung gegeben, und die Einholung dieser Zustimmung liegt in der Verantwortung des Benutzers. Der Benutzer wird Prozis von allen Schäden freistellen, die durch die Verwendung solcher Bilder und/oder Videos entstehen könnten.\n\nSobald der Inhalt geteilt wurde, gehört er ausschließlich Prozis, das das Recht hat, den Inhalt zu veröffentlichen und/oder zu verbreiten und/oder zu nutzen und/oder zu reproduzieren und/oder zu kommunizieren und/oder zu ändern, durch alle technischen Mittel und auf jede Art und Weise, ohne Einschränkung, ohne Fristen und ohne Anspruch auf Entschädigung oder Schadenersatz für die beteiligten oder betroffenen Personen.\n\nNach dem Hochladen eines Inhalts behält sich Prozis das Recht vor, nur das Material sichtbar zu lassen, das nach seinem alleinigen Ermessen nicht schädlich für das Ansehen anderer Personen ist und das nicht die aktuelle Moral beleidigt oder anderweitig die Rechte anderer verletzt; voreingenommen, diffamierend, obszön, vulgär, verleumderisch, rassistisch ist oder Werbung für eine kommerzielle Aktivität macht, die nicht im Zusammenhang mit dem vorgeschlagenen Thema steht oder die beabsichtigt, eine andere Marke, ein anderes Produkt oder eine andere Dienstleistung als die des „Sozialen Netzwerks“ zu fördern, mit Inhalten, die nicht originär vom Benutzer stammen, d.h. aus anderen Quellen kopiert wurden, oder Inhalten, die gegen das portugiesische Rechtssystem, die öffentliche Ordnung, die Datenschutzbestimmungen und die geltenden Gesetze verstoßen.\n\nProzis behält sich außerdem das Recht vor, jederzeit Kommentare und/oder Inhalte, die in ihrem „Sozialen Netzwerk“ veröffentlicht wurden, unabhängig oder auf Anfrage Dritter sowie von Justizbehörden zu entfernen, falls Streitigkeiten bezüglich der Rechtmäßigkeit oder Legitimität der besagten Veröffentlichung oder des Kommentars bestehen. Nur wenn der Inhalt nach Meinung der Moderatoren des „Sozialen Netzwerks“ als angemessen angesehen wird, bleibt er sichtbar.\n\nNach dem Hochladen eines Inhalts in das „Soziale Netzwerk“ behält sich Prozis das Recht vor, den Inhalt des Benutzers direkt auf seinen digitalen Plattformen erneut hochzuladen oder zu teilen, um seine Marke zu fördern.',
    WITHOUT_POSTS: 'Es gibt noch keine Beiträge.',
    WITHOUT_POSTS_STATISTICS:
      'Zwischen den ausgewählten Daten gibt es keine Beiträge.'
  },
  SUCCESS: {
    COPIED_TO_CLIPBOARD: 'Link erfolgreich in die Zwischenablage kopiert!',
    CREATED_SUCCESSFULLY: 'Erfolgreich erstellt!',
    ERROR_PUBLISHING_INSAGRAM:
      'Der Beitrag wurde auf Instagram veröffentlicht.',
    INSTAGRAM_PUBLISHING_SUCCESS:
      'Der Beitrag wurde erfolgreich auf Instagram veröffentlicht.',
    POST_CREATED_SUCCESSFULLY: 'Erfolgreich erstellt!',
    POST_SAVED_SUCCESSFULLY: 'Erfolgreich aktualisiert!',
    POST_SUCCESSFULLY_DELETED: 'Erfolgreich gelöscht.',
    SAVED_SUCCESSFULLY: 'Erfolgreich aktualisiert!',
    SUCCESSFULLY_DELETED: 'Erfolgreich gelöscht.',
    SUCCESSFULLY_REPLIED: 'Erfolgreich beantwortet.'
  },
  TOOLTIP: {},
  WARNING: {
    ACCPET_TERMS_AND_CONDITIONS:
      'Bitte akzeptieren Sie die Geschäftsbedingungen!',
    EMPTY_PROFILE_IMAGE: 'Sie müssen ein Profilbild hochladen!',
    INVALID_FORM: 'Ungültiges Formular!'
  }
};
